import { useCallback, useEffect } from "react";
import { authService } from "services/authService";

/**
 * Hook to automatically refresh access token before it expires
 * Checks every minute and refreshes if token will expire in next 5 minutes
 */
export const useTokenRefresh = () => {
  const checkAndRefreshToken = useCallback(async () => {
    // Only check if user is authenticated
    if (!authService.getAccessToken()) {
      return;
    }

    // Check if token will expire in next 5 minutes (300,000 ms)
    const expiryStr = localStorage.getItem("tokenExpiry");
    if (!expiryStr) return;

    const expiry = parseInt(expiryStr, 10);
    const timeUntilExpiry = expiry - Date.now();

    // If token expires in less than 5 minutes, refresh it
    if (timeUntilExpiry < 300000 && timeUntilExpiry > 0) {
      await authService.refreshToken();
    }
  }, []);

  useEffect(() => {
    // Check immediately on mount
    checkAndRefreshToken();

    // Then check every minute
    const interval = setInterval(checkAndRefreshToken, 60000);

    return () => clearInterval(interval);
  }, [checkAndRefreshToken]);
};
